import React from "react"
import types from "prop-types"
import * as ReactModal from "react-modal" // https://github.com/reactjs/react-modal

export { default as ModalHeader } from "./ModalHeader"

ReactModal.defaultStyles.overlay.zIndex = "99"

export const DEFAULT_MODAL_STYLE = {
  content: {
    border: "1px solid #E5E7F5",
    boxShadow: "-10px 0 100rem -2rem rgba(90, 93, 131, 0.4)",
    borderRadius: "8px",
    height: "fit-content",
    left: "50%",
    margin: "1rem",
    maxWidth: "600px",
    minWidth: "300px",
    padding: "40px 20px",
    top: "50%",
    transform: "translate(calc(-50% - 1rem), -50%)",
    width: "calc(100% - 2rem)",
  },
}

const Modal = ({
  children, isOpen, style = DEFAULT_MODAL_STYLE, onAfterOpen = () => {}, ...rest
}) => (
  <ReactModal
    isOpen={isOpen}
    appElement={document.querySelector("body")}
    style={style}
    onAfterOpen={onAfterOpen}
    {...rest}
  >
    {children}
  </ReactModal>
)

Modal.propTypes = {
  onAfterOpen: types.func,
  children: types.node.isRequired,
  isOpen: types.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: types.object,
}

export default Modal
